<template>
  <div>
    <vs-button
      @click="activateProgram()"
      style=" padding-bottom: 0; padding-top: 0"
      color="success"
      type="gradient"
      icon="send"
      radius
    ></vs-button>
    <vs-prompt
      title="Kullanıcıyı Görevlendir"
      acceptText="Görev Ver"
      cancelText="Vazgeç"
      :active.sync="activePrompt"
      @accept="cargoTracking"
    >
      <div class="con-exemple-prompt">
        <span>Kullanıcı</span>
        <b-row>
          <b-col>
            <vs-input
              v-model="cargoTrakingID"
              placeholder="Kargo Kodu"
              label="name"
            ></vs-input>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
export default {
  data() {
    return {
      activePrompt: false,
      cargoTrakingID: ""
    };
  },
  methods: {
    activateProgram() {
      this.activePrompt = true;
    },
    cargoTracking(order) {
      
    }
  }
};
</script>
